import i18n from 'i18next';
import { dinheiro } from './formato';

/**
 * Fase 2 (W19, K4): marca de inadimplência derivada que o Contas publica (`contas.inadimplencia`) e o Cadastros devolve na
 * lista e na ficha do parceiro (`inadimplencia`), só para quem tem `contas.ver`. Ausente: sem o Contas ou sem a permissão.
 */
export interface MarcaInadimplencia {
  parceiro_id: string;
  dias: number;
  documentos: number;
  vencimento_mais_antigo: string;
  /** Fase 2, W34: líquido da nota de crédito em aberto (mesma empresa e moeda); `creditos_centavos` é o abatido. */
  valores: { moeda: string; valor_centavos: number; creditos_centavos?: number }[];
}

/**
 * Frase da marca no idioma do app: "2 faturas vencidas, a mais antiga há 40 dias · R$ 1.500,00". O valor passa pelo
 * formatador de dinheiro (no modo discreto vira o marcador, só com o símbolo da moeda); moedas diferentes não se somam.
 */
export function textoInadimplencia(m: MarcaInadimplencia): string {
  const valores = m.valores.map((v) => dinheiro(v.valor_centavos, v.moeda)).join(' + ');
  return `${i18n.t('inadimplencia.faturas', { count: m.documentos })}, ${i18n.t('inadimplencia.atraso', { count: m.dias })} · ${valores}`;
}

/** Títulos a receber do parceiro no Contas (a mesma rota dos vínculos da ficha). */
export const linkTitulosDoParceiro = (parceiroId: string) => `/financeiro/contas/a-receber?parceiro_id=${parceiroId}`;
